import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import Layout from './components/Layout';
import Login from './pages/Login/Login'; 
import Reset from './pages/Password/Reset'; 
import Home from './pages/Home/Home'; 
import Profil from './pages/Profil/Profil'; 
import Proses from './pages/Proses/Proses'; 
import DetailProses from './pages/Proses/ProsesDetail'; 
import History from './pages/History/History'; 
import DetailHistory from './pages/History/DetailHistory'; 
import DetailImage from './pages/History/DetailImage'; 
import Document from './pages/Document/Document'; 
import PdfViewer from './pages/Document/PdfViewer'; 
import Schedules from './pages/Schedules/Schedules';
import SchedulesDetails from './pages/Schedules/SchedulesDetails';
import Request from './pages/Request/Request';
import RequestService from './pages/Request/RequestService';
import PrivateRoute from './components/PrivateRoute';
import ResetValidate from './pages/Password/ResetValidate';
import NewPassword from './pages/Password/NewPassword';

function AutoLogout() {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location/path

  useEffect(() => {
    // Exclude certain paths from AutoLogout
    const excludedPaths = ['/login', '/forgot-password', '/forgot-password-validate', '/reset-password'];
    if (excludedPaths.includes(location.pathname)) {
      return; // Don't run AutoLogout if the user is on any of these pages
    }

    const loginTime = localStorage.getItem('loginTime');
    const maxSessionDuration = 60 * 60 * 1000; // 1 hour in milliseconds

    if (loginTime) {
      const currentTime = new Date().getTime();
      if (currentTime - loginTime > maxSessionDuration) {
        localStorage.clear();
        Swal.fire({
          title: 'Session Expired',
          text: 'Your session has expired. Please log in again.',
          icon: 'warning',
          confirmButtonText: 'OK'
        }).then(() => {
          navigate('/login');
        });
      }
    }
  }, [navigate, location]);

  return null;
}

function App() {
  return (
    <Router>
      <AutoLogout /> {/* This component checks for session expiration, but will be excluded from login and other routes */}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<Reset />} />
        <Route path="/forgot-password-validate" element={<ResetValidate />} />
        <Route path="/reset-password" element={<NewPassword />} />
        
        {/* Wrap protected routes with PrivateRoute */}
        <Route 
          path="/" 
          element={
            <PrivateRoute>
              <Layout><Home /></Layout>
            </PrivateRoute>
          } 
        />
         <Route 
          path="/profil" 
          element={
            <PrivateRoute>
              <Layout title="Profil" subtitle="Update Data"><Profil /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/history" 
          element={
            <PrivateRoute>
              <Layout title="History" subtitle="History AC Services"><History /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/detailhistory/:id" 
          element={
            <PrivateRoute>
              <Layout title="Detail History" ><DetailHistory /></Layout>
            </PrivateRoute>
          } 
        />
         <Route 
          path="/detail-images" 
          element={
            <PrivateRoute>
              <Layout title="Bukti Pengerjaan" subtitle="Galleri Bukti Pengerjaan"><DetailImage /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/document" 
          element={
            <PrivateRoute>
              <Layout title="Document" subtitle="List of Documents"><Document /></Layout>
            </PrivateRoute>
          } 
        />
         <Route 
          path="/pdf-viewer" 
          element={
            <PrivateRoute>
              <Layout title="Document" subtitle="PDF Viewer"><PdfViewer /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/schedules" 
          element={
            <PrivateRoute>
              <Layout title="Schedules" subtitle="Upcoming Services"><Schedules /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/schedule-detail/:id" 
          element={
            <PrivateRoute>
              <Layout title="Detail Schedule" ><SchedulesDetails /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/request" 
          element={
            <PrivateRoute>
              <Layout title="Request" subtitle="Request Services"><Request /></Layout>
            </PrivateRoute>
          } 
        />
         <Route 
          path="/request-service" 
          element={
            <PrivateRoute>
              <Layout title="Request Service" subtitle="Request Services AC"><RequestService /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/proses-pengerjaan" 
          element={
            <PrivateRoute>
              <Layout title="Proses" subtitle="Proses Pengerjaan"><Proses /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/detailproses/:id" 
          element={
            <PrivateRoute>
              <Layout title="Detail Proses Pengerjaan" ><DetailProses /></Layout>
            </PrivateRoute>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;
